"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogHeader = exports.getStyles = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var PreventUserSelect_1 = require("../../styles/PreventUserSelect");
var TabStyles_1 = require("../../styles/TabStyles");
var TextEllipsis_1 = require("../../styles/TextEllipsis");
var Declarative_1 = require("../../utils/Declarative");
var GlobalPointerEventCapturer_1 = require("../../utils/GlobalPointerEventCapturer");
var ReactHelpers_1 = require("../../utils/ReactHelpers");
var UserInteraction_1 = require("../../utils/UserInteraction");
var CloseButtonWidget_1 = require("../Button/CloseButtonWidget");
var DialogWidget_1 = require("./DialogWidget");
exports.getStyles = function () {
    return {
        DraggableHeader: {
            cursor: 'move',
        },
        Header: tslib_1.__assign(tslib_1.__assign({}, PreventUserSelect_1.PreventUserSelect), { flexShrink: 0, minHeight: TabStyles_1.TabStyles.Sizing.BaseUnit * 5 }),
        TitleBar: tslib_1.__assign({ fontSize: TabStyles_1.TabStyles.Typography.Sizing.Default, color: TabStyles_1.TabStyles.Typography.Color.Primary, backgroundColor: TabStyles_1.TabStyles.Colors.F2, height: '100%', minHeight: 'inherit', paddingRight: TabStyles_1.TabStyles.Spacing.LargeSpace, paddingLeft: TabStyles_1.TabStyles.Spacing.LargeSpace, display: 'flex', alignItems: 'center', lineHeight: 'normal' }, TextEllipsis_1.TextEllipsis),
        TitleBarWithCloseButton: {
            paddingRight: 0,
        },
        LightweightTitleBar: {
            fontSize: 16,
            height: '100%',
            minHeight: 'inherit',
            paddingTop: 20,
            paddingLeft: TabStyles_1.TabStyles.Spacing.ExtraLargeSpace - TabStyles_1.TabStyles.Sizing.BorderWidth,
            paddingRight: TabStyles_1.TabStyles.Spacing.ExtraLargeSpace - TabStyles_1.TabStyles.Sizing.BorderWidth,
            paddingBottom: TabStyles_1.TabStyles.Spacing.DefaultSpace,
            display: 'flex',
            alignItems: 'center',
            lineHeight: 'normal'
        },
        LightweightTitleBarCloseButton: {
            top: 10,
            right: 10,
            position: 'absolute'
        },
        Title: tslib_1.__assign({ flexGrow: 1 }, TextEllipsis_1.TextEllipsis),
    };
};
var DialogHeader = /** @class */ (function (_super) {
    tslib_1.__extends(DialogHeader, _super);
    function DialogHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleStart = function (event) {
            var _a;
            var targetNode = event.target;
            if (!((_a = _this.closeButtonElement) === null || _a === void 0 ? void 0 : _a.contains(targetNode)) && _this.props.positioningBehavior === DialogWidget_1.DialogPositioningBehavior.Draggable) {
                event.preventDefault();
                var clientPosition = UserInteraction_1.getClientPosition(event);
                var dialogClientRect = _this.props.getDraggableDialogClientRect();
                _this.startXPosition = clientPosition.x - dialogClientRect.left;
                _this.startYPosition = clientPosition.y - dialogClientRect.top;
                _this.addMouseEventListeners();
            }
        };
        /**
         * Moves the dialog container
         */
        _this.handleMove = function (event) {
            event.preventDefault(); // prevent touch events from firing mouse events
            var clientPosition = UserInteraction_1.getClientPosition(event);
            _this.props.setDraggableDialogPosition({
                top: clientPosition.y - _this.startYPosition,
                left: clientPosition.x - _this.startXPosition
            });
        };
        _this.handleStop = function (event) {
            event.preventDefault(); // prevent touch events from firing mouse events
            _this.removeMouseEventListeners();
        };
        _this.handleCloseButtonRef = function (ref) {
            _this.closeButtonElement = ref;
        };
        _this.handleCloseButtonClick = function (e) {
            var _a, _b;
            e.preventDefault();
            (_b = (_a = _this.props).onCloseRequest) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
        _this.handleRef = function (ref) {
            if (_this.globalPointerEventCapturer) {
                _this.removeMouseEventListeners();
            }
            if (!ref) {
                return;
            }
            _this.globalPointerEventCapturer = new GlobalPointerEventCapturer_1.GlobalPointerEventCapturer(ref, _this.handleMove, _this.handleStop);
            // React has a very old bug about synthetic `touchstart` handlers working poorly with Chrome -- so we bind it natively here instead
            // See https://github.com/facebook/react/issues/9809
            ref.addEventListener('touchstart', _this.handleStart, { passive: false });
        };
        return _this;
    }
    DialogHeader.prototype.componentWillUnmount = function () {
        this.removeMouseEventListeners();
    };
    DialogHeader.prototype.addMouseEventListeners = function () {
        this.globalPointerEventCapturer.addListeners();
    };
    DialogHeader.prototype.removeMouseEventListeners = function () {
        this.globalPointerEventCapturer.removeListeners();
    };
    DialogHeader.prototype.render = function () {
        var styles = exports.getStyles();
        var headerStyle = tslib_1.__assign(tslib_1.__assign({}, styles.Header), Declarative_1.conditional(this.props.positioningBehavior === DialogWidget_1.DialogPositioningBehavior.Draggable, styles.DraggableHeader));
        var showTitleBar = false;
        var titleBarStyle = {};
        var closeButtonWrapperStyle = {
            display: 'inline-block',
        };
        if (this.props.type === DialogWidget_1.DialogType.NormalWithTitleBar) {
            showTitleBar = true;
            titleBarStyle = tslib_1.__assign(tslib_1.__assign({}, styles.TitleBar), Declarative_1.conditional(this.props.showCloseButton, styles.TitleBarWithCloseButton));
        }
        else if (this.props.type === DialogWidget_1.DialogType.LightweightTitleBar) {
            showTitleBar = true;
            titleBarStyle = tslib_1.__assign({}, styles.LightweightTitleBar);
            closeButtonWrapperStyle = tslib_1.__assign({}, styles.LightweightTitleBarCloseButton);
        }
        var closeButtonProps = {
            testId: this.props.testId,
            title: Localize_1.Messages.closeDialog(),
            onClick: this.handleCloseButtonClick,
            ref: this.handleCloseButtonRef
        };
        return (React.createElement("div", tslib_1.__assign({}, ReactHelpers_1.EventUtilsOptOut, { "data-tb-test-id": Declarative_1.makeTestId(this.props.testId, 'Header'), onMouseDown: this.handleStart, ref: this.handleRef, style: headerStyle }), showTitleBar &&
            React.createElement("div", { "data-tb-test-id": Declarative_1.makeTestId(this.props.testId, 'TitleBar'), style: titleBarStyle },
                !!this.props.title &&
                    React.createElement("div", { children: this.props.title, id: this.props.id, style: styles.Title }),
                this.props.showCloseButton &&
                    React.createElement("div", { style: closeButtonWrapperStyle },
                        React.createElement(CloseButtonWidget_1.DialogCloseButtonWidget, tslib_1.__assign({}, closeButtonProps))))));
    };
    return DialogHeader;
}(React.Component));
exports.DialogHeader = DialogHeader;
//# sourceMappingURL=DialogHeader.js.map